import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'qw-ui-lib-v2';
import I18n from '../../../config/i18n';
import { validateSchema } from '../../common/validations';
import {
  enablePageScroll,
  disablePageScroll,
} from '../../common/utils/uiHelper';
import CloseButtonDialog from '../../views/common/CloseButtonDialog';
import InventoryEdit from './index';

const SCHEMA_ID = 'http://partners.qubewire.com/schemas/drives';

export default class DrivesModalEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false, drives: null, errors: null, showErrors: false };

    this.handleSave = this.handleSave.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.updateDriveInventory = this.updateDriveInventory.bind(this);
  }

  handleOpen() {
    disablePageScroll();
    this.setState({ open: true, drives: this.props.inventory.drives });
  }

  handleClose() {
    enablePageScroll();
    this.setState({
      open: false,
      drives: null,
      errors: null,
      showErrors: false,
    });
  }

  handleSave() {
    if (this.state.errors && this.state.errors.drives) {
      return this.setState({ showErrors: true });
    }
    if (this.state.drives && !(this.state.errors && this.state.errors.drives)) {
      this.props.onSave(this.state.drives);
      this.handleClose();
    }
  }

  updateDriveInventory(drives) {
    const errors = validateSchema(drives, SCHEMA_ID);
    this.setState({ drives: drives, errors: { drives: errors } });
  }

  renderChildren() {
    if (this.state.open) {
      return (
        <div className="ml1" style={{ color: 'black' }}>
          <InventoryEdit
            driveTypes={this.state.drives}
            drives={this.state.drives}
            shouldHideDriveTitle={true}
            errors={this.state.showErrors && this.state.errors}
            updateDriveInventory={this.updateDriveInventory}
            showErrors
          />
        </div>
      );
    } else {
      return <div />;
    }
  }

  render() {
    const actions = [
      <Button
        key="close"
        variant="secondary"
        onClick={this.handleClose}
        style={{ minWidth: '56px' }}
      >
        {I18n.t('close')}
      </Button>,
      <Button
        key="save"
        variant="primary"
        onClick={this.handleSave}
        style={{ minWidth: '56px' }}
      >
        {I18n.t('save')}
      </Button>,
    ];

    return (
      <CloseButtonDialog
        actions={actions}
        title={I18n.t('driveInventory')}
        open={this.state.open}
        onRequestClose={this.handleClose}
        minHeight="144px"
        width="100%"
        maxWidth="36rem"
      >
        {this.renderChildren()}
      </CloseButtonDialog>
    );
  }
}

DrivesModalEdit.propTypes = {
  onSave: PropTypes.func.isRequired,
};
